<div class="context-view">
  @if (projectNo() !== null) {
    <div class="top-bar">
      <div class="context-title">
        @if (project().isPrime) {
          <app-badge-variant
            badge="none"
            label="PL"
            [shape]="Shape.Shield"
            backgroundColor="var(--prime-logistics-color-1)"
            [tooltip]="'ASSIGNMENT.INFOFILTER.PRIME_LOGISTIC' | translate" />
        }
        {{ 'PROJECT.CONTEXT.TITLE' | translate }} {{ project().ProjectNo }}
      </div>
      <!-- tabs -->

      <div class="context-header">
        <dx-tabs [dataSource]="tabs" [(selectedIndex)]="selectedTabIndex"> </dx-tabs>
      </div>
      <div class="f-1"></div>
      <div class="context-corner">
        <dx-button class="small-button" icon="close" (onClick)="close()"></dx-button>
      </div>
    </div>

    <div class="top-cell-context">
      <dx-multi-view
        class="flex"
        [dataSource]="tabs"
        [(selectedIndex)]="selectedTabIndex"
        [loop]="false"
        [animationEnabled]="true"
        [swipeEnabled]="false">
        <div *dxTemplate="let selection of 'item'">
          @if (selection.type === 'planning') {
            <app-project-planning
              [project]="project"
              (reloadDataRequired)="reloadProjectDetail()"></app-project-planning>
          } @else if (selection.type === 'detail') {
            <app-project-detail [project]="project" (changed)="reloadProjectDetail()"></app-project-detail>
          } @else if (selection.type === 'courier') {
            <app-project-courier [project]="project"></app-project-courier>
          }
        </div>
      </dx-multi-view>
    </div>

    <div class="bottom-cell-context">
      <app-project-footer-panel [project]="project" (changed)="reloadProjectDetail()"></app-project-footer-panel>
    </div>
  } @else {
    <dx-load-indicator class="large-indicator"></dx-load-indicator>
  }
</div>
